import { create } from 'zustand';

interface CustomerSalesDialogStore {
  isOpen: boolean;
  storeId: number | null;
  monthYear: string;

  // Actions
  openDialog: (params: { storeId: number; monthYear: string }) => void;
  closeDialog: () => void;
  reset: () => void;
}

export const useCustomerSalesDialogStore = create<CustomerSalesDialogStore>(
  (set) => ({
    isOpen: false,
    storeId: null,
    monthYear: '',

    openDialog: (params) =>
      set({
        isOpen: true,
        storeId: params.storeId,
        monthYear: params.monthYear,
      }),
    closeDialog: () => set({ isOpen: false }),
    reset: () =>
      set({
        isOpen: false,
        storeId: null,
        monthYear: '',
      }),
  }),
);
